import { images } from '../constants';

const blogs = [
{
  id: 1,
  image: images.blog1,
  category: "cake design",
  date: "9 July, 2025",
  admin: "Admin",
  heading: "The Art of Cake Decorating: Tips & Tricks",
  important: {
    content: "Cake decorating is both an art and a science. Whether you’re a beginner or an experienced baker, mastering the basics of piping, layering, and fondant work will elevate your baking skills.",
    intro: "Baking Expert"
  },
  paragraph: {
    para1: "Start with a smooth cake surface using crumb coating techniques. This creates a clean base for your decorations and prevents crumbs from ruining your designs.",
    para2: "Experiment with piping bags and nozzles to create elegant patterns, floral designs, and borders. Consistency in frosting texture is key to achieving professional results.",
    para3: "Fondant and edible decorations add creativity and personalization. Practice rolling, shaping, and coloring fondant to craft themed cake toppers and intricate details.",
    para4: "With patience and practice, cake decorating becomes an enjoyable and rewarding hobby. Showcase your creations at birthdays, weddings, and celebrations to spread joy through your artistry."
  },
  gallery: [
    images.blog1Gallery1,
    images.blog1Gallery2
  ],
  tags: ["cake", "decorating", "baking"],
  comments: [
    {
      id: 1,
      image: images.blog1Comment1,
      name: "Liam Turner",
      date: "5 September, 2025",
      content: "This guide really inspired me to try new decorating styles. Thanks for the helpful tips!",
      replies: [
        {
          id: 1,
          image: images.blog1Comment2,
          name: "Sophia Nguyen",
          date: "5 September, 2025",
          content: "Same here! I finally learned how to properly use piping bags."
        }
      ]
    },
    {
      id: 2,
      image: images.blog1Comment3,
      name: "James Patel",
      date: "5 September, 2025",
      content: "Would love a video tutorial for these techniques in the future!"
    }
  ]
},
{
  id: 2,
  image: images.blog2,
  category: "pastry pairing",
  date: "02 July, 2025",
  admin: "Admin",
  heading: "The Perfect Pairings: Coffee and Pastries",
  important: {
    content: "The right combination of coffee and pastries enhances flavors, creating a delightful morning or afternoon ritual. From buttery croissants to sweet rolls, each pastry finds its perfect coffee match.",
    intro: "Pastry & Coffee Enthusiast"
  },
  paragraph: {
    para1: "A classic buttery croissant pairs wonderfully with a bold espresso, balancing rich and crisp textures with strong, smooth coffee notes.",
    para2: "Sweet fruit danishes complement light and floral coffee blends, creating a refreshing combination perfect for brunch or teatime.",
    para3: "Chocolate-based pastries like brownies or pain au chocolat shine when enjoyed with robust dark roasts or creamy cappuccinos.",
    para4: "Experimenting with different pairings helps you discover new favorites and enjoy your coffee breaks as a truly sensory experience."
  },
  gallery: [
    images.blog2Gallery1,
    images.blog2Gallery2
  ],
  tags: ["coffee", "pastry", "baking"],
  comments: [
    {
      id: 1,
      image: images.blog2Comment1,
      name: "Emma Clark",
      date: "30 August, 2025",
      content: "Loved these pairing ideas! I tried the croissant and espresso combo this morning—it was amazing.",
      replies: [
        {
          id: 1,
          image: images.blog2Comment2,
          name: "Daniel Lee",
          date: "30 August, 2025",
          content: "Agreed! Coffee and pastries are the perfect duo."
        }
      ]
    },
    {
      id: 2,
      image: images.blog2Comment3,
      name: "Sophia Nguyen",
      date: "30 August, 2025",
      content: "Now I have to try all these combinations. Thanks for the tips!"
    }
  ]
},
{
  id: 3,
  image: images.blog3,
  category: "cake design",
  date: "29 June, 2025",
  admin: "Admin",
  heading: "Wedding Cake Trends: What's In and What's Out",
  important: {
    content: "Wedding cakes are a centerpiece of celebration. Keeping up with trends ensures your cake reflects your unique style and the latest design innovations.",
    intro: "Event Cake Designer"
  },
  paragraph: {
    para1: "Current trends include minimalist designs with clean lines, delicate floral arrangements, and elegant textures like marble and watercolor effects.",
    para2: "Unique flavors such as lavender, matcha, and salted caramel are replacing traditional vanilla and chocolate, offering guests delightful surprises.",
    para3: "What's out? Over-the-top fondant decorations and heavily tiered cakes are being replaced by more organic and approachable designs.",
    para4: "Couples are opting for cakes that reflect their personalities, such as single-tier statement cakes or dessert table alternatives like cupcake towers."
  },
  gallery: [
    images.blog3Gallery1,
    images.blog3Gallery2
  ],
  tags: ["cake", "trends", "baking"],
  comments: [
    {
      id: 1,
      image: images.blog3Comment1,
      name: "Olivia Carter",
      date: "13 August, 2025",
      content: "So helpful as I plan my wedding! Loving the minimalist trend.",
      replies: [
        {
          id: 1,
          image: images.blog3Comment2,
          name: "Emily Harris",
          date: "13 August, 2025",
          content: "Same here! Can't wait to try something modern for our cake."
        }
      ]
    },
    {
      id: 2,
      image: images.blog3Comment3,
      name: "James Walker",
      date: "13 August, 2025",
      content: "Great insights! The shift toward natural designs is refreshing."
    }
  ]
},
{
  id: 4,
  image: images.blog4,
  category: "kids baking",
  date: "25 June, 2025",
  admin: "Admin",
  heading: "Baking with Kids: Fun and Educational Treats",
  important: {
    content: "Baking with children not only sparks creativity but also teaches valuable lessons like patience, measuring, and following instructions—all while having fun.",
    intro: "Family Baking Enthusiast"
  },
  paragraph: {
    para1: "Start with simple recipes such as cookies, cupcakes, or brownies. These easy-to-make treats give kids a sense of accomplishment and delicious results.",
    para2: "Involve them in every step: measuring ingredients, mixing batter, and decorating finished goods. This hands-on experience boosts their confidence and coordination.",
    para3: "Use the opportunity to teach math (measuring), science (mixing ingredients), and safety (handling kitchen tools). Learning through baking makes education tasty and fun.",
    para4: "Celebrate their efforts by sharing the baked treats with friends and family, turning your kitchen activities into cherished family traditions."
  },
  gallery: [
    images.blog4Gallery1,
    images.blog4Gallery2
  ],
  tags: ["kids", "baking", "pastry"],
  comments: [
    {
      id: 1,
      image: images.blog4Comment1,
      name: "Sophia Clark",
      date: "26 July, 2025",
      content: "Loved this idea! My kids had a blast baking cupcakes yesterday.",
      replies: [
        {
          id: 1,
          image: images.blog4Comment2,
          name: "Laura Green",
          date: "26 July, 2025",
          content: "Same here! Baking has become our weekend tradition now."
        }
      ]
    },
    {
      id: 2,
      image: images.blog4Comment3,
      name: "Daniel Lee",
      date: "26 July, 2025",
      content: "Great tips for involving kids in the kitchen safely!"
    }
  ]
},
{
  id: 5,
  image: images.blog5,
  category: "global pastries",
  date: "12 June, 2025",
  admin: "Admin",
  heading: "Exploring International Pastries: A Culinary Journey",
  important: {
    content: "Pastries hold a special place in every culture’s culinary traditions. From delicate French croissants to Middle Eastern baklava, each pastry reflects its region's history, ingredients, and baking techniques.",
    intro: "Culinary Explorer"
  },
  paragraph: {
    para1: "France’s buttery croissants and éclairs showcase the artistry of flaky dough and rich fillings, creating timeless classics enjoyed worldwide.",
    para2: "In Italy, cannoli and sfogliatelle highlight a passion for creamy, crunchy, and flaky textures, often paired with fresh ricotta and citrus flavors.",
    para3: "The Middle East brings baklava and maamoul, where nuts, honey, and aromatic spices come together in layers of crisp pastry and sweet syrup.",
    para4: "Asia offers mochi and egg tarts, blending traditional ingredients with modern twists, creating pastries that surprise and delight with each bite."
  },
  gallery: [
    images.blog5Gallery1,
    images.blog5Gallery2
  ],
  tags: ["global", "pastry", "baking"],
  comments: [
    {
      id: 1,
      image: images.blog5Comment1,
      name: "Luca Romano",
      date: "10 June, 2025",
      content: "This was such a delightful read! I want to try making baklava next weekend.",
      replies: [
        {
          id: 1,
          image: images.blog5Comment2,
          name: "Fatima Noor",
          date: "10 June, 2025",
          content: "Great choice! Baklava is delicious and surprisingly fun to make."
        }
      ]
    },
    {
      id: 2,
      image: images.blog5Comment3,
      name: "Hannah Kim",
      date: "10 June, 2025",
      content: "Loved learning about pastries from around the world. Please share recipes!"
    }
  ]
},
{
  id: 6,
  image: images.blog6,
  category: "baking tips",
  date: "08 June, 2025",
  admin: "Admin",
  heading: "The Science of Baking: Understanding the Basics",
  important: {
    content: "Baking is not only an art but also a precise science. Understanding how ingredients interact with each other and respond to heat is the key to consistently delicious results.",
    intro: "Pastry Scientist"
  },
  paragraph: {
    para1: "Flour provides structure through gluten formation, giving baked goods their shape and chewiness. Different flours produce different textures.",
    para2: "Leavening agents like baking powder, baking soda, and yeast create air bubbles, allowing baked items to rise and become light and fluffy.",
    para3: "Fats like butter and oil tenderize the crumb and add richness, while sugars not only sweeten but also contribute to browning and moisture retention.",
    para4: "Proper temperature and timing ensure chemical reactions occur at the right moment, preventing dense, dry, or unevenly baked results."
  },
  gallery: [
    images.blog6Gallery1,
    images.blog6Gallery2
  ],
  tags: ["baking", "science", "basics"],
  comments: [
    {
      id: 1,
      image: images.blog6Comment1,
      name: "Ethan Davis",
      date: "10 June, 2025",
      content: "This was super helpful! I always wondered why my cakes didn’t rise properly.",
      replies: [
        {
          id: 1,
          image: images.blog6Comment2,
          name: "Sophie Brown",
          date: "10 June, 2025",
          content: "Same here! I’ll pay more attention to my leavening agents next time."
        }
      ]
    },
    {
      id: 2,
      image: images.blog6Comment3,
      name: "Mia Zhang",
      date: "10 June, 2025",
      content: "Please write more about how different ovens affect baking results!"
    }
  ]
},
{
  id: 7,
  image: images.blog7,
  category: "cake design",
  date: "21 May, 2025",
  admin: "Admin",
  heading: "Mastering Cake Decorating: Techniques & Secrets",
  important: {
    content: "Cake decorating is a blend of skill, creativity, and precision. From mastering buttercream textures to creating intricate fondant designs, every element matters in turning a simple cake into a masterpiece.",
    intro: "Decorating Specialist"
  },
  paragraph: {
    para1: "Start with a smooth foundation by properly crumb-coating your cakes. A steady hand and the right tools can create a flawless surface for decorating.",
    para2: "Mastering piping techniques such as rosettes, borders, and lettering will add personality and elegance to your creations.",
    para3: "Fondant work involves rolling, cutting, and molding edible art, offering limitless possibilities for themed cakes and personalized designs.",
    para4: "Finishing touches like edible glitter, fresh flowers, and customized cake toppers elevate your cake's visual appeal and charm."
  },
  gallery: [
    images.blog7Gallery1,
    images.blog7Gallery2
  ],
  tags: ["cake", "decorating", "baking"],
  comments: [
    {
      id: 1,
      image: images.blog7Comment1,
      name: "Olivia Bennett",
      date: "16 June, 2025",
      content: "This gave me some great ideas for my next birthday cake project!",
      replies: [
        {
          id: 1,
          image: images.blog7Comment2,
          name: "Lucas Martin",
          date: "16 June, 2025",
          content: "Totally agree! I’m going to try the fondant flowers next weekend."
        }
      ]
    },
    {
      id: 2,
      image: images.blog7Comment3,
      name: "Ella Robinson",
      date: "16 June, 2025",
      content: "Could you do a video tutorial on piping techniques? I'd love to watch that!"
    }
  ]
},
{
  id: 8,
  image: images.blog8,
  category: "pastry pairing",
  date: "15 May, 2025",
  admin: "Admin",
  heading: "Best Coffee & Pastry Combinations for Every Mood",
  important: {
    content: "Pairing the right pastry with your coffee enhances the overall tasting experience. Whether you're feeling cozy, energized, or adventurous, there's a perfect combination for you.",
    intro: "Coffee & Pastry Expert"
  },
  paragraph: {
    para1: "For a comforting morning start, pair a buttery croissant with a smooth latte. The creamy texture complements the flaky pastry beautifully.",
    para2: "Feeling energized? Choose a bold espresso shot alongside a sweet chocolate muffin for a powerful flavor contrast.",
    para3: "When you want something light, match a fruit tart with a mild Americano, balancing sweetness with subtle bitterness.",
    para4: "For adventurous moods, try international pairings like a Turkish coffee with baklava or a cappuccino with an almond biscotti."
  },
  gallery: [
    images.blog8Gallery1,
    images.blog8Gallery2
  ],
  tags: ["coffee", "pastry", "trends"],
  comments: [
    {
      id: 1,
      image: images.blog8Comment1,
      name: "Daniel Foster",
      date: "21 June, 2025",
      content: "Tried the croissant and latte combo this morning—absolutely perfect!",
      replies: [
        {
          id: 1,
          image: images.blog8Comment2,
          name: "Sophia Wright",
          date: "21 June, 2025",
          content: "Same here! I’ll try the espresso and muffin pairing tomorrow."
        }
      ]
    },
    {
      id: 2,
      image: images.blog8Comment3,
      name: "James Howard",
      date: "21 June, 2025",
      content: "Could you share some vegan coffee and pastry pairings in a future post?"
    }
  ]
},
{
  id: 9,
  image: images.blog9,
  category: "cake design",
  date: "07 May, 2025",
  admin: "Admin",
  heading: "Wedding Cake Styles: Trending & Timeless Designs",
  important: {
    content: "Wedding cakes are more than desserts; they’re artistic centerpieces. Whether you’re drawn to trending styles or timeless elegance, the perfect cake reflects your love story.",
    intro: "Cake Design Specialist"
  },
  paragraph: {
    para1: "Trendy wedding cake styles this season include sleek monochrome designs, metallic finishes, and watercolor effects, offering a contemporary vibe for modern couples.",
    para2: "Timeless favorites, such as tiered white cakes with intricate piping and cascading sugar flowers, continue to capture hearts with their elegant charm.",
    para3: "Couples seeking unique statements are embracing geometric shapes, textured buttercream, and hand-painted details on their cakes.",
    para4: "Whether you prefer tradition or trend, work closely with your baker to create a cake that complements your theme and makes your day unforgettable."
  },
  gallery: [
    images.blog9Gallery1,
    images.blog9Gallery2
  ],
  tags: ["cake", "trends", "decorating"],
  comments: [
    {
      id: 1,
      image: images.blog9Comment1,
      name: "Charlotte Reed",
      date: "6 May, 2025",
      content: "Loved reading about the metallic cake trend! Definitely going for that look on my big day.",
      replies: [
        {
          id: 1,
          image: images.blog9Comment2,
          name: "Ella Thomas",
          date: "6 May, 2025",
          content: "I’m still in love with the classic floral designs—timeless beauty!"
        }
      ]
    },
    {
      id: 2,
      image: images.blog9Comment3,
      name: "Ryan Parker",
      date: "6 May, 2025",
      content: "Would love to see more rustic and outdoor wedding cake ideas in a future post."
    }
  ]
},
{
  id: 10,
  image: images.blog10,
  category: "kids baking",
  date: "25 April, 2025",
  admin: "Admin",
  heading: "Fun Baking Projects for Kids: Learning Through Sweets",
  important: {
    content: "Baking with kids is a hands-on way to teach measurements, patience, and creativity—all while making delicious memories together.",
    intro: "Family Baking Enthusiast"
  },
  paragraph: {
    para1: "Simple recipes like sugar cookies, mini cupcakes, and no-bake bars allow children to learn basic baking skills in a safe and enjoyable way.",
    para2: "Decorating baked goods with colorful frosting, sprinkles, and edible toppers gives kids a chance to express their creativity.",
    para3: "Baking projects also teach life skills such as following instructions, working together, and understanding kitchen safety.",
    para4: "Create themed baking days for holidays, birthdays, or rainy weekends to make family time extra sweet and meaningful."
  },
  gallery: [
    images.blog10Gallery1,
    images.blog10Gallery2
  ],
  tags: ["kids", "baking", "fun"],
  comments: [
    {
      id: 1,
      image: images.blog10Comment1,
      name: "Rachel Evans",
      date: "26 April, 2025",
      content: "Such cute and fun ideas! Can’t wait to try baking cupcakes with my daughter this weekend.",
      replies: [
        {
          id: 1,
          image: images.blog10Comment2,
          name: "Laura Jenkins",
          date: "26 April, 2025",
          content: "We did the cookie project last night—huge success!"
        }
      ]
    },
    {
      id: 2,
      image: images.blog10Comment3,
      name: "Thomas Wright",
      date: "26 April, 2025",
      content: "These projects are a great way to keep kids entertained and learning. Thanks for sharing!"
    }
  ]
},
{
  id: 11,
  image: images.blog11,
  category: "global pastries",
  date: "10 April, 2025",
  admin: "Admin",
  heading: "A Taste of the World: Discovering Global Pastries",
  important: {
    content: "Pastries tell the tale of a culture's flavors, traditions, and celebrations—each bite revealing something unique from its country of origin.",
    intro: "Culinary Explorer"
  },
  paragraph: {
    para1: "From buttery French croissants to Middle Eastern baklava, every culture has its own signature pastry that’s enjoyed in celebrations or daily rituals.",
    para2: "Asian pastries like Japanese mochi and Chinese egg tarts offer a delightful contrast of textures and flavors, blending traditional ingredients with creative presentation.",
    para3: "Latin America brings us churros and empanadas, while Europe tempts with strudels, cannoli, and Danish pastries—each crafted with generations of love.",
    para4: "Discovering and baking these pastries at home allows you to travel the world through your kitchen and savor the sweet diversity of global cuisine."
  },
  gallery: [
    images.blog11Gallery1,
    images.blog11Gallery2
  ],
  tags: ["global", "pastry", "baking"],
  comments: [
    {
      id: 1,
      image: images.blog11Comment1,
      name: "Daniel Lee",
      date: "11 April, 2025",
      content: "I love how this article highlights so many unique pastries! Can’t wait to try baking some of these.",
      replies: [
        {
          id: 1,
          image: images.blog11Comment2,
          name: "Sophia Patel",
          date: "11 April, 2025",
          content: "We tried making baklava at home—it was so much fun and so delicious!"
        }
      ]
    },
    {
      id: 2,
      image: images.blog11Comment3,
      name: "Isabella Rossi",
      date: "11 April, 2025",
      content: "This makes me want to travel just for the pastries. Wonderful write-up!"
    }
  ]
},
{
  id: 12,
  image: images.blog12,
  category: "baking tips",
  date: "01 April, 2025",
  admin: "Admin",
  heading: "Baking Basics Explained: The Science Behind Perfect Treats",
  important: {
    content: "Baking is as much about chemistry as it is about creativity. Understanding the science behind each step ensures consistent, delicious results every time.",
    intro: "Baking Scientist"
  },
  paragraph: {
    para1: "From the reaction between baking soda and acidic ingredients to the role of gluten in creating structure, baking relies on precise chemical interactions.",
    para2: "Temperature control is critical. Too hot, and your cake may collapse; too cool, and your cookies won’t spread properly. Even ingredient temperature plays a key role.",
    para3: "Moisture content affects texture, while leavening agents help baked goods rise to fluffy perfection. Measuring ingredients accurately is essential to achieving the right balance.",
    para4: "Mastering the science behind baking transforms your kitchen into a laboratory of sweet success, helping you troubleshoot problems and create treats with confidence."
  },
  gallery: [
    images.blog12Gallery1,
    images.blog12Gallery2
  ],
  tags: ["baking", "science", "basics"],
  comments: [
    {
      id: 1,
      image: images.blog12Comment1,
      name: "Henry Adams",
      date: "23 March, 2025",
      content: "I finally understand why my bread was dense! This was super helpful.",
      replies: [
        {
          id: 1,
          image: images.blog12Comment2,
          name: "Laura Chen",
          date: "23 March, 2025",
          content: "Same here! Getting the oven temp right made all the difference for me."
        }
      ]
    },
    {
      id: 2,
      image: images.blog12Comment3,
      name: "Carlos Rivera",
      date: "23 March, 2025",
      content: "Loved this scientific approach to baking. Makes me want to experiment more in the kitchen!"
    }
  ]
},


];

export default blogs;